/* eslint-disable */
export * from "./gql";